const setUpSmoothAnchorScroll = () => {
  document.addEventListener("click", (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('a[href*="#"]')
      : null;

    if (!(trigger instanceof HTMLAnchorElement)) {
      return;
    }

    const rawHref = (trigger.getAttribute("href") || "").trim();
    if (rawHref === "" || rawHref === "#") {
      return;
    }

    let parsedUrl;
    try {
      parsedUrl = new URL(rawHref, window.location.href);
    } catch (error) {
      return;
    }

    if (
      parsedUrl.origin !== window.location.origin ||
      parsedUrl.pathname !== window.location.pathname ||
      parsedUrl.search !== window.location.search ||
      parsedUrl.hash === ""
    ) {
      return;
    }

    const targetId = decodeURIComponent(parsedUrl.hash.slice(1));
    if (targetId === "") {
      return;
    }

    const targetElement = document.getElementById(targetId);
    if (!(targetElement instanceof HTMLElement)) {
      return;
    }

    event.preventDefault();

    const header = document.querySelector(".site-header");
    const headerOffset = header instanceof HTMLElement
      ? header.getBoundingClientRect().height
      : 0;
    const top = targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset - 12;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: "smooth",
    });
  });
};

export default setUpSmoothAnchorScroll;
